import { Skeleton } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetManyTransports } from 'api/transports/use-get-many-transports.ts';
import { usePaginationParams } from 'shared/hooks/use-pagination-params';
import { useTransportFiltersStore } from 'shared/stores/use-transport-filters';
import { Pagination } from 'components/pagination';
import { TransportCreate } from 'components/transport/transport-create';
import { TransportFilter } from 'components/transport/transport-filter';
import { TransportsList } from 'components/transport/transport-list';

export const TransportsPage = () => {
  const { page, limit, handlePageChange } = usePaginationParams();
  const { search, filters } = useTransportFiltersStore();
  const { data: transports, isLoading } = useGetManyTransports({ page, limit, search, filters, withNotUsed: true });

  const header = <PageHeader title={<TransportFilter />} extra={[<TransportCreate key={TransportCreate.name} />]} />;

  return (
    <DefaultPageLayout header={header}>
      {!isLoading ? (
        <>
          <TransportsList transports={transports?.data || []} isLoading={isLoading} />
          <Pagination total={transports?.pagination?.total} page={page} limit={limit} onChange={handlePageChange} />
        </>
      ) : (
        <Skeleton />
      )}
    </DefaultPageLayout>
  );
};
